export const chargeCalculationMethod = {
  ticketsTotal: 0,
  highestTicketPrice: 1,
};
